/**
 * Single source of truth for site identity, contact details and social profiles.
 * Everything SEO related reads from here, so a domain or phone change is a
 * one-line edit rather than a hunt across templates.
 */
export const site = {
  name: 'Clients Preferred Property Hub',
  shortName: 'Clients Preferred',

  // IMPORTANT: must match the live domain exactly, including www or no-www.
  // Every canonical URL, Open Graph URL and sitemap entry is built from this.
  origin: 'https://clientspreferred.com',

  locale: 'en_IN',
  lang: 'en-IN',
  themeColor: '#b91c1c',

  defaultTitle:
    'Clients Preferred Property Hub | Real Estate Consultancy in Mohali, Kharar & Chandigarh',
  defaultDescription:
    'Trust-driven real estate consultancy in Tricity. Verified GMADA and RERA approved projects across Mohali, Kharar, Chandigarh and Panchkula, with end-to-end guidance for homebuyers and investors.',

  // 1200x630 image placed in public/. See the delivery notes.
  defaultImage: '/og-cover.jpg',

  founder: 'Vipandeep Singh',
  phone: '+917087931778',
  phoneDisplay: '+91 70879 31778',
  email: 'clientspreferredpropertyhub@gmail.com',

  address: {
    street: 'Gillco Valley, Sector 127',
    locality: 'Kharar',
    region: 'Punjab',
    postalCode: '140301',
    country: 'IN',
  },

  geo: {
    latitude: 30.7299,
    longitude: 76.6586,
  },

  areaServed: ['Mohali', 'Kharar', 'Chandigarh', 'Panchkula', 'Zirakpur'],

  social: [
    'https://www.facebook.com/clients.preferred.property.hub/',
    'https://www.instagram.com/clientspreferredpropertyhub/',
    'https://www.youtube.com/@ClientsPreferredPropertyHub',
  ],
};

export default site;
